import React, { useState } from "react";
import axios from "axios";
// import { createProduct } from '../actions/productActions';
import { createregisterevent } from '../actions/registereventActions';
import { Form, Button, Row, Col, FormGroup, FormLabel, FormControl, NavLink } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const CreateRegistryForm = () => {
  const [formData, setFormData] = useState({
    regtitle: '',
    regdate: '',
    regmessage: '',
    regaddinfo: '',
    regtype: '',
    r_title: '',
    r_fname: '',
    r_lname: '',
    r_email: '',
    r_phone: '',
    r_address: '',
    r_city: '',
    r_state: '',
    r_country: '',
    r_zip: '',
    user_id:'',
    handle:'',
  });
  

    /** VALIDATION RULES OF REG FORM */

    const [errors, setErrors] = useState({});

    const validateForm = () => {
      
      let isValid = true;
      let newErrors = {};

      if (!formData.regtitle.trim()) {
        newErrors.regtitle = 'Giftregistry title is required';
        isValid = false;
      }
      
      if (!formData.regdate.trim()) {
        newErrors.regdate = 'Giftregistry date is required';
        isValid = false;
      }
      
      if (!formData.regmessage.trim()) {
        newErrors.regmessage = 'Giftregistry message is required';
        isValid = false;
      }

      if (!formData.regtype.trim()) {
        newErrors.regtype = 'Please select event type';
        isValid = false;
      }      
      
      if (!formData.r_title.trim()) {
        newErrors.r_title = 'Registrant title is required';
        isValid = false;
      }

      if (!formData.r_fname.trim()) {
        newErrors.r_fname = 'Registrant first name is required';
        isValid = false;
      }
      
      if (!formData.r_lname.trim()) {
        newErrors.r_lname = 'Registrant last name is required';
        isValid = false;
      }
      
      if (!formData.r_email.trim()) {
        newErrors.r_email = 'Registrant Email is required';
        isValid = false;
      } else if (!/^\S+@\S+\.\S+$/.test(formData.r_email)) {
        newErrors.r_email = 'Invalid email format';
        isValid = false;
      }

      if (!formData.r_phone.trim()) {
        newErrors.r_phone = 'Registrant phone number is required';
        isValid = false;
      }
      
      if (!formData.r_address.trim()) {
        newErrors.r_address = 'Registrant address is required';
        isValid = false;
      }
      
      if (!formData.r_city.trim()) {
        newErrors.r_city = 'Registrant city is required';
        isValid = false;
      }
      
      if (!formData.r_state.trim()) {
        newErrors.r_state = 'Registraint state is required';
        isValid = false;
      }

      if (!formData.r_country.trim()) {
        newErrors.r_country = 'Registraint country is required';
        isValid = false;
      }

      if (!formData.r_zip.trim()) {
        newErrors.r_zip = 'Registrant zip/postal code is required';
        isValid = false;
      }

      setErrors(newErrors);
      return isValid;
    };  

    /** END FORM VALIDATION RULES METHOD */
  
    const handleChange = (event) => {
      const { name, value } = event.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
  
  const handleSubmit =  (e)  => {      
      e.preventDefault();      
      if(validateForm()){  
        fetch('https://wiser-ai.expertvillagemedia.com/api/newregistry', {
          method: "POST",
          dataType: "jsonp",
          headers: 
          { 
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          },      
          body: JSON.stringify({
            regtype: formData.regtype,
            regtitle: formData.regtitle,        
            regmessage: formData.regmessage,
            regdate: formData.regdate,
            regaddinfo: formData.regaddinfo,
            r_zip:formData.r_zip,
            r_title:formData.r_title,
            r_state:formData.r_state,
            r_phone:formData.r_phone,
            r_lname:formData.r_lname,
            r_fname:formData.r_fname,
            r_email: formData.r_email,
            r_country:formData.r_country,
            r_city:formData.r_city,
            r_address: formData.r_address,
            user_id:'31',
            customer_id:`${window.Shopline.customer.id}`,
            customer_email:`${window.Shopline.customer.email}`,
            customer_name:`${window.Shopline.customer.name}`,
            handle:`${window.Shopline.handle}`,
          }),
        })
        .then((response) => response.json())
        .then((responseJson) => {
            toast("Giftregistry added successfully.!");
            setTimeout(removeRegData, 1000);
        })
        .catch((error) => {
            console.error(error);
        });        
      }       
  };

  function removeRegData(){
    setFormData({
      regtitle: '',regdate: '',regmessage: '',regaddinfo: '',regtype: '',r_title: '',r_fname: '',r_lname: '',r_email: '',r_phone: '',r_address: '',r_city: '',r_state: '',
      r_country: '',r_zip: '',user_id:'',handle:'',
      // Reset other form fields
    }); 
  }

  return (
    <div  className="evm-register-event">      
      {window.Shopline.customer === undefined  &&
        <div className='create-registry-wr'>
          <h1>Please login before to access gift registry</h1>
          <a href="/user/signIn" > Sign In </a>          
        </div>
      }

      {window.Shopline.customer !== '' && window.Shopline.customer !== undefined  &&
        <div className="container">
          <div className='create-registry-wr'>
            <h2>Create New Registry</h2>
            <div className='form-wrapper'>
              <form className="giftregsubmitform" onSubmit={handleSubmit}>

              <div className="giftregform">
                  <h4>Registry Profile</h4>
                  <div className='form-fields'>
                    <div className='form-control  display_none' >
                      <label>E *</label>
                      <input ttype='text' name="regcreateddate" value={formData.regcreateddate} />                            
                    </div>                
                    <div className='form-control '>                    
                      <label>Registry title *</label>                    
                      <input type='text' name='regtitle' id='regtitle'  value={formData.regtitle} onChange={handleChange} />
                      {errors.regtitle && <div className="ev_error">{errors.regtitle}</div>}
                    </div>
                    <div className='form-control '>
                      <label>Event date *</label>
                      <input type='date' name='regdate' id='regdate' value={formData.regdate} onChange={handleChange} />
                      {errors.regdate && <div className="ev_error">{errors.regdate}</div>}
                    </div>
                    <div className='form-control '>
                      <label>Public message to Friends and family *</label>
                      <input type='text' name='regmessage' id='regmessage' value={formData.regmessage} onChange={handleChange} />
                      {errors.regmessage && <div className="ev_error">{errors.regmessage}</div>}
                    </div>
                    <div className='form-control '>
                      <label>Add aditional info</label>
                      <input type='text' name='regaddinfo' value={formData.regaddinfo} onChange={handleChange} />
                      {errors.regtype && <div className="ev_error"> {' '} </div>}
                    </div>
                    <div className='form-control '>
                      <label>Type of event *</label>
                      <select name="regtype" id="regtype" value={formData.regtype} onChange={handleChange} >
                        <option value="">Select Event Type</option>
                        <option value="Baby">Baby</option>
                        <option value="Birthday">Birthday</option>
                        <option value="Wedding">Wedding</option>
                        <option value="Christmas">Christmas</option>
                        <option value="Holiday">Holiday</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors.regtype && <div className="ev_error">{errors.regtype}</div>}
                    </div>
                  </div>
                </div>

                <div className="giftregform">
                  <h4>Registrant Information</h4>
                  <div className='form-fields'>
                    <div className='form-control'>
                      <label>Title *</label>
                      <input type='text' name='r_title' id="r_title" value={formData.r_title} onChange={handleChange} />
                      {errors.r_title && <div className="ev_error">{errors.r_title}</div>}
                    </div>
                    <div className='form-control '>
                      <label>First name *</label>
                      <input type='text' name='r_fname' id='r_fname' value={formData.r_fname} onChange={handleChange} />
                      {errors.r_fname && <div className="ev_error">{errors.r_fname}</div>}
                    </div>
                    <div className='form-control '>
                      <label>last name *</label>
                      <input type='text' name='r_lname' id='r_lname' value={formData.r_lname} onChange={handleChange} />
                      {errors.r_lname && <div className="ev_error">{errors.r_lname}</div>}
                    </div>
                    <div className='form-control '>
                      <label>Email *</label>
                      <input type='email' name='r_email' id='r_email' value={formData.r_email} onChange={handleChange} />
                      {errors.r_email && <div className="ev_error">{errors.r_email}</div>}
                    </div>
                    <div className='form-control '>
                      <label>Phone *</label>
                      <input type='tel' name='r_phone' id='r_phone' value={formData.r_phone} onChange={handleChange} />
                      {errors.r_phone && <div className="ev_error">{errors.r_phone}</div>}
                    </div>
                  </div>
                </div>

                <div className="giftregform">
                  <h4>Shipping Information</h4>
                  <div className='form-fields'>
                    <div className='form-control '>
                      <label>Address *</label>
                      <input type='text' name='r_address' id='r_address' value={formData.r_address} onChange={handleChange} />
                      {errors.r_address && <div className="ev_error">{errors.r_address}</div>}
                    </div>
                    <div className='form-control '>
                      <label>City *</label>
                      <input type='text' name='r_city' id='r_city' value={formData.r_city} onChange={handleChange} />
                      {errors.r_city && <div className="ev_error">{errors.r_city}</div>}
                    </div>
                    <div className='form-control'>
                      <label>State *</label>
                      <input type='text' name='r_state' id='r_state' value={formData.r_state} onChange={handleChange} />
                      {errors.r_state && <div className="ev_error">{errors.r_state}</div>}
                    </div>
                    <div className='form-control'>
                      <label>Country *</label>
                      <input type='text' name='r_country' id='r_country' value={formData.r_country} onChange={handleChange} />
                      {errors.r_country && <div className="ev_error">{errors.r_country}</div>}
                    </div>
                    <div className='form-control'>
                      <label>Zip/Postal Code *</label>
                      <input type='text' name='r_zip' id='r_zip' value={formData.r_zip} onChange={handleChange} />
                      {errors.r_zip && <div className="ev_error">{errors.r_zip}</div>}
                    </div>
                  </div>
                </div>

                <div className="giftregform">
                    <div className='form-control'>
                      <input type='submit' name='r_submit' className='submit-rgstry' value='Create Registry' />
                      <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                      />
                    </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      }      
    </div>
  )
}

export default CreateRegistryForm
